var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DamagedHeader',{attrs:{"header":"สินค้าชำรุดรอย้ายเข้าคลังรอคืน","img_header":_vm.header_image,"link_back":"stock/storage/damagedstorage"}}),_c('Damaged_product')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }